import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { AbstractControl, NgModel } from '@angular/forms';
import {
  FineUploaderBasic, CoreOptions, ChunkingOptions, CorsOptions, RequestOptions, CoreEvents, ChunkData,
  ParamNamesOptions
} from 'fine-uploader/lib/core';
import { environment } from '../../../../../environments/environment';
import { ExcelImportService,  MsgResult, UserProfileService } from '../../../../core';
import { Subscription } from 'rxjs';
import { AuditStdImport, ImportResults } from '../../../rate-audit/ra-create/utilities/auditstd-import-model';
import { AuditStdEdit } from '../../../rate-audit/ra-create/utilities/auditstd-edit-model';
import { ProcessSettingsComponent } from '../../../rate-audit/ra-create/process-settings/process-settings.component';
import { AlertComponent, EnumAlertType } from '../../../../common/component/alert/alert.component';
import { ConfirmDialogComponent } from '../../../../common/component/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-rvrs-create-from-file',
  templateUrl: './rvrs-create-from-file.component.html',
  styleUrls: ['./rvrs-create-from-file.component.scss']
})
export class RvrsCreateFromFileComponent implements OnInit {
  @ViewChild('fileItem', { static: true }) fileItem: NgModel;
  @ViewChild(AlertComponent, { static: true }) alerter: AlertComponent;
  @ViewChild(ConfirmDialogComponent, { static: true }) confirmDialog: ConfirmDialogComponent

  @Output() fileChosen = new EventEmitter<any>();
  showModal:boolean = false;
  public showSpinner: boolean = false;
  myFiles: FileList = null;
  selectFileControl: AbstractControl = null;
  private domainStr: string;
  selectedFileOnServer = "";
  sessionGuid = "";
  subscriptions: Subscription[] = [];

  public okayToExit: boolean = true;
  public selectedFileToUpload: string = "";
  auditId: string;
  uploadFilesize: string;
  TotalPropertyCount:string;
  constructor(
    private excelImportService: ExcelImportService
    , private userProfileService:UserProfileService
  ) {
    this.domainStr = environment.baseWebApiUrl;
  }

  ngOnInit() {
    this.setupFineUploader();
  }

  onFileSelected(event) {
    console.log('onFileSelected');
    this.onRemoveSelectedFile();

    if (!event.currentTarget || !event.currentTarget.files || event.currentTarget.files.length <= 0){
      return; //most likely the user canceled after a file had been selected
    }

    this.isBusy(true);
    this.myFiles = event.currentTarget.files;
    this.file = event.currentTarget.files[0];
    this.selectFileControl = this.fileItem.control;

    var arr = Array.from(this.myFiles);
    this.uploader.addFiles(arr);
  }
  file:any;
  setupFineUploader(){
    const cors: CorsOptions = { expected: true, sendCredentials: true };
    const paramNames: ParamNamesOptions = {/*partIndex: 'SEQ'*/ };
    const chunking: ChunkingOptions = { concurrent: { enabled: false }, enabled: true, mandatory: false, partSize: 2000000, paramNames: paramNames };
    const request: RequestOptions = {
      inputName: 'filename', /*method: 'GET', paramsInBody: false, */
      endpoint: this.domainStr + 'Upload/UploadFile'
    }; //?filename={0}&append={1}&SEQ={2}&Last={3}
    const callbacks: CoreEvents = {
      onError: (id: number, name: string, errorReason: string, xhr: XMLHttpRequest) => {
        console.log('onError ' + id);
        this.resetUploadControls();
        if(errorReason.indexOf('invalid extension') > 0)
          this.showUploadError(errorReason)
        else if (errorReason != "No files to upload.") {
          this.showUploadError("Error uploading file.")
        }
      },
      onProgress: (id: number, name: string, uploadedBytes: number, totalBytes: number) => { console.log('onProgress ' + id); },
      onResume: (id: number, name: string, chunkData: any) => { console.log('onResume ' + id); },
      onUploadChunk: (id: number, name: string, chunkData: ChunkData) => { console.log('onUploadChunk ' + id); },
      onUploadChunkSuccess: (id: number, chunkData: ChunkData, responseJSON: any, xhr: XMLHttpRequest) => { console.log('onUploadChunkSuccess ' + id); },
      onStatusChange: (id: number, oldStatus: string, newStatus: string) => { console.log('onStatusChange ' + id); },
      onSubmit: (id: number, name: string) => { console.log('onSubmit ' + id); },
      onSubmitted: (id: number, name: string) => { console.log('onSubmitted ' + id); },
      onUpload: (id: number, name: string) => { console.log('onUpload ' + id + ' ' + name); },
      onComplete: (id: number, name: string, responseJSON: any, xhr: XMLHttpRequest) => {
        console.log('onComplete ' + id);
        if(responseJSON.success){
        this.selectedFileOnServer = responseJSON.uniqueFilename;
        this.sessionGuid = responseJSON.sessionGuid;
        const s1 = this.excelImportService.importReverseAuditExcelFile(responseJSON.uniqueFilename)
          .subscribe(
          (data) => {
            if (data.success) {
              this.setUploadedData(name, data)
            } else {
              if (data.message == "delayed") {
                this.excelImportService.importReverseAuditFileRetryDelayedFile(data.optionalParameters[0])
                .subscribe(
                (data2) => {
                  if (data2.success) {
                    this.setUploadedData(name, data2)
                  } else {
                    this.showUploadError("Error, the import file was not processed in time or failed.", data.optionalParameters);
                  }
                },
                (err) => {
                  console.log('Error in importExcelRetryDelayedFile call');
                  console.log(err);
                  this.showUploadError("Error processing request.", (err&&err.message&&err.message=="delayed")?["Task timed out."]:err.optionalParameters);
                });

              } else {
                this.showUploadError("Error while converting the import file.", data.optionalParameters);
              }
            }
          },
          (err) => {
            console.log('Error in importExcelFile');
            console.log(err);
            if(err.status == 401){
                this.userProfileService.TakeUserToLogoutPage();
            } else {
             this.showUploadError("Error processing file after it was uploaded, verify file format.");
            }
          });
          this.subscriptions.push(s1);
        }
        else 
        {
          if (responseJSON.error != undefined && responseJSON.error.indexOf("file is corrupted") > 0) {
            this.showUploadError(responseJSON.error);
          }
          else {
            this.showUploadError("Error uploading file");
          }
        }
      },
    };
    const options: CoreOptions = { autoUpload: true, debug: true, validation:{
      allowedExtensions: ['xls', 'xlsx']
    }, chunking: chunking, cors: cors, request: request, callbacks: callbacks };
    this.uploader = new FineUploaderBasic(options);

  }
  uploader:FineUploaderBasic;
  onRemoveSelectedFile() {
    this.selectedFileToUpload = "";
    this.selectedFileOnServer = "";
    this.sessionGuid = "";
    this.TotalPropertyCount = "";
    this.uploadFilesize="";
    this.myFiles = null;
    this.auditId = "";
    this.fileChosen.emit({inputValid:false, selectedAuditID: null});
  }

  isBusy(enable: boolean) {
    this.showSpinner = enable;
  }

  resetUploadControls() {
    this.isBusy(false);
    this.uploader.reset();
    this.myFiles = null;
    this.file = null;
  }

  showUploadError(msg: string, msgs?:string[]) {
    this.resetUploadControls();

    if(msgs && msgs.length>1){
      this.confirmDialog.confirm(msg, msgs.join("\r\n"),"Error").subscribe();
    }
    else{
      msg +=  (msgs?(" - " +msgs.join(" ")):"");
      console.log(msg);
      this.alerter.showAlertMessage(5000, msg, EnumAlertType.Error);
    }
    this.fileChosen.emit({inputValid:false, selectedAuditID: null});
  }

  setUploadedData(filename: string, data: MsgResult) {
    this.resetUploadControls();
    this.okayToExit = false;
    this.selectedFileToUpload = filename;
    this.auditId = data.message;
    console.log(this.auditId);
    let filesize = 0;
    if(data.optionalParameters.length>=2){
      this.TotalPropertyCount = data.optionalParameters[1];
      filesize = Number.parseInt( data.optionalParameters[0]) ;
    }

    if (filesize > 1024) {
      var sizeStr = " KB";
      filesize = filesize / 1024;
      if (filesize > 1024) {
        filesize = filesize / 1024;
        sizeStr = " MB";
      }
      this.uploadFilesize = filesize.toFixed(2) + sizeStr;
    }

    let inputValid = data.success;
    this.fileChosen.emit({
      inputValid: inputValid,
      selectedAuditID: this.auditId
    });
  }
}
